<template>
  <v-app>
    <v-container fluid class="pa-2">
      <v-form @submit.prevent="submitForm">
        <v-row>

          <!-- LEFT : QC MASTER -->
          <v-col cols="12" md="3">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                  QC Information
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-row dense>

                    <!-- Production Order -->
                    <v-col cols="12 mt-3">
                      <v-select
                        label="Production Order *"
                        v-model="production_order_id.value.value"
                        :items="$store.getters.getProductionOrderList"
                        item-title="code"
                        item-value="id"
                        variant="outlined"
                        density="compact"
                        @update:model-value="onProductionOrderChange"
                        :error-messages="production_order_id.errorMessage.value"
                      />
                    </v-col>

                    <!-- Style -->
                    <v-col cols="12">
                      <v-select
                        label="Style *"
                        v-model="style_id.value.value"
                        :items="itemList"
                        item-title="style.code"
                        item-value="style_id"
                        variant="outlined"
                        density="compact"
                        @update:model-value="onStyleChange"
                      />
                    </v-col>

                    <!-- Color -->
                    <v-col cols="12">
                      <v-select
                        label="Color *"
                        v-model="color_id.value.value"
                        :items="colorList"
                        item-title="name"
                        item-value="color_id"
                        variant="outlined"
                        density="compact"
                        @update:model-value="onColorChange"
                      />
                    </v-col>

                    <!-- QC Date -->
                    <v-col cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="QC Date *"
                        prepend-inner-icon="mdi-calendar"
                        prepend-icon=""
                        v-model="qc_date.value.value"
                        density="compact"
                        variant="outlined"
                      ></v-date-input>
                    </v-col>

                    <!-- Remarks -->
                    <v-col cols="12">
                      <v-textarea
                        label="Remarks"
                        v-model="remarks"
                        rows="2"
                        variant="outlined"
                        density="compact"
                      />
                    </v-col>

                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- RIGHT : DETAILS -->
          <v-col cols="12" md="9">

            <v-expansion-panels v-model="panel1" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                  QC Details
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-card cllass="mt-3" flat >
                    <v-card-text>
                      <v-table>
                        <tbody>
                          <tr v-for="(d, i) in details" :key="i">
                            <td>
                              <v-text-field
                                v-model="d.size_name"
                                type="text"
                                variant="outlined"
                                label="Size*"
                                density="compact"
                                readonly="true"
                                disabled="true"
                                hide-details
                              ></v-text-field>
                            </td>

                            <td>
                              <v-text-field
                                v-model.number="d.checked_qty"
                                type="number"
                                variant="outlined"
                                label="Checked Qty*"
                                density="compact"
                                hide-details
                                @update:model-value="onCheckQtyChange(i)"
                              ></v-text-field>
                            </td>

                            <td>
                              <v-text-field
                                v-model.number="d.passed_qty"
                                type="number"
                                label="Passed Qty*"
                                density="compact"
                                variant="outlined"
                                hide-details
                                @update:model-value="onPassQtyChange(i)"
                              />
                            </td>

                            <td>
                              <v-text-field
                                v-model.number="d.failed_qty"
                                type="number"
                                label="Failed Qty*"
                                density="compact"
                                variant="outlined"
                                hide-details
                                @update:model-value="onFailedQtyChange(i)"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-card-text>

                    <v-card-actions class="justify-end">

                      <v-btn class="bg-grey-darken-1 me-2" variant="flat" @click="submit(0)" :loading="loading && submittingStatus === 0">
                        Draft
                      </v-btn>
                      <v-btn class="bg-primary" variant="flat" @click="submit(1)" :loading="loading && submittingStatus === 1">
                        {{ isEdit ? 'Update' : 'Save' }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script setup>
  import { ref,onMounted } from "vue";
  import { useForm, useField } from "vee-validate";
  import { useStore } from "vuex";
  import { useRoute, useRouter } from "vue-router";
  import { toast } from "vue3-toastify";
  import formattedDate from "@/plugins/dateFormatter";

  const store = useStore();
  const route = useRoute();
  const router = useRouter();

  const panel = ref([0]);
  const panel1 = ref([0]);
  const isEdit = ref(false);

  const itemList = ref([]);
  const colorList = ref([]);
  const details = ref([]);

  const remarks = ref("");

  const { handleSubmit, setFieldValue } = useForm({
    initialValues: { status: 1 }
  });

  const production_order_id = useField("production_order_id");
  const production_order_item_id = useField("production_order_item_id");
  const style_id = useField("style_id");
  const color_id = useField("color_id");
  const qc_date = useField("qc_date");

  function onCheckQtyChange(index){
    (details.value)[index].failed_qty = (details.value)[index].checked_qty - (details.value)[index].passed_qty;
  }
  function onPassQtyChange(index){
    (details.value)[index].failed_qty = (details.value)[index].checked_qty - (details.value)[index].passed_qty;
  }
  function onFailedQtyChange(index){
    (details.value)[index].passed_qty = (details.value)[index].checked_qty - (details.value)[index].failed_qty;
  }

  const onProductionOrderChange = (id) => {
    const order = store.getters.getProductionOrderList.find(o => o.id === id);
    itemList.value = order?.items || [];
  };

  const onStyleChange = (styleId) => {
    const item = itemList.value.find(i => i.style_id === styleId);
    production_order_item_id.value.value = item.id;

    // unique colors
    const map = {};
    item.breakdowns.forEach(b => {
      map[b.color_id] = { color_id: b.color_id, name: b.color.name };
    });
    colorList.value = Object.values(map);
  };

  const onColorChange = (colorId) => {
    const item = itemList.value.find(i => i.id === production_order_item_id.value.value);

    details.value = item.breakdowns
      .filter(b => b.color_id === colorId)
      .map(b => ({
        production_breakdown_id: b.id,
        size_id: b.size_id,
        size_name: b.size.name,
        checked_qty: 0,
        passed_qty: 0,
        failed_qty: 0
      }));
  };

  /* ---------------- SUBMIT ---------------- */

  const submit = (status) => {
    setFieldValue("status", status);
    submitForm();
  };

  const submitForm = handleSubmit((values) => {
    const payload = {
      ...values,
      qc_date : formattedDate(qc_date.value.value),
      remarks: remarks.value,
      details: details.value
    };

    const action = isEdit.value
      ? store.dispatch("updateProductionQc", { id: route.params.id, data: payload })
      : store.dispatch("saveProductionQc", payload);

    action
      .then((res) => {
        if(res.data.success == false){ toast.error(res?.data?.message); return;}
        toast.success("QC Saved Successfully");
        router.push({ name: "qc-records" });
      })
      .catch(err => toast.error(err.response?.data?.message));
  });

  onMounted(async () => {
    await store.dispatch("getProductionOrderList");
    if (route.params.id) {
      isEdit.value = true;
      const id = route.params.id;

      store.dispatch("getProductionQcById", { id })
        .then(res => {
          const data = res.data.data;

          setFieldValue("production_order_id", data.production_order_id);
          setFieldValue("production_order_item_id", data.production_order_item_id);
          setFieldValue("style_id", data.style_id);
          setFieldValue("color_id", data.color_id);
          setFieldValue("qc_date", data.qc_date);
          setFieldValue("status", data.status);

          remarks.value = data.remarks || "";

          onProductionOrderChange(data.production_order_id);
          onStyleChange(data.style_id);
          onColorChange(data.color_id);

          details.value = data.details.map(d => ({
            production_breakdown_id: d.id,
            size_id: d.size_id,
            size_name: d.size_name,
            checked_qty: d.checked_qty,
            passed_qty: d.passed_qty,
            failed_qty: d.failed_qty,
          }));
        })
        .catch(() => {
          toast.error("Failed to load QC data");
        });
    }
  });


</script>

<style scoped>
.panel-header {
  background: #eceff1;
  font-weight: 600;
}
</style>
